import { Link } from "react-router-dom";
import { getTypeCount } from "@/lib/works";
import { TYPE_DESCRIPTIONS, TYPE_LABELS } from "@/types/work";
import type { WorkType } from "@/types/work";

const ITEMS: { type: WorkType; icon: string; bubble: string; ring: string }[] = [
  {
    type: "drama",
    icon: "ri-tv-2-line",
    bubble: "bg-primary-500 text-background-50 dark:text-foreground-950",
    ring: "group-hover:border-primary-300",
  },
  {
    type: "movie",
    icon: "ri-film-line",
    bubble: "bg-accent-500 text-accent-950",
    ring: "group-hover:border-accent-300",
  },
  {
    type: "web",
    icon: "ri-device-line",
    bubble: "bg-secondary-700 text-background-50",
    ring: "group-hover:border-secondary-400",
  },
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            影视分类快捷入口
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按类型快速进入频道，发现更多符合口味的影视作品
          </p>
        </div>
        <Link
          to="/category/drama"
          className="hidden items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 md:inline-flex cursor-pointer"
        >
          浏览全部分类
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
        {ITEMS.map((item) => (
          <Link
            key={item.type}
            to={`/category/${item.type}`}
            className={`group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 ${item.ring} cursor-pointer md:p-6`}
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg text-2xl ${item.bubble} md:h-16 md:w-16`}
            >
              <i className={item.icon}></i>
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {TYPE_LABELS[item.type]}
                </h3>
                <span className="rounded-full bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600">
                  {getTypeCount(item.type)} 部
                </span>
              </div>
              <p className="clamp-2 mt-1.5 text-xs leading-relaxed text-foreground-600">
                {TYPE_DESCRIPTIONS[item.type]}
              </p>
            </div>
            <i className="ri-arrow-right-line shrink-0 text-xl text-foreground-400 transition-colors group-hover:text-primary-500"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}